import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import './FullScreen.scss';

const htmlDOMnode = document.documentElement;
const fullScreenDOMNode = document.getElementById('mn_fullScreen');

function FullScreen({ children, dataTopLayer }) {
  useEffect(() => {
    htmlDOMnode.classList.add('mn_noScroll');

    return () => {
      htmlDOMnode.classList.remove('mn_noScroll');
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ReactDOM.createPortal(
    dataTopLayer ? (<div className="mn_fullScreen" data-top-layer>{children}</div>) :
      (<div className="mn_fullScreen">{children}</div>),
    fullScreenDOMNode,
  );
}

export default FullScreen;
